<!-- @format -->
<sports>
  <h3 class="heading-03 margin-spacing-2_top">趣味</h3>
  <textarea
    class="textarea_input"
    value="{ props.data.hobby }"
    oninput="{ e => onText(e, 'hobby') }"
  ></textarea>
  <h3 class="heading-03 margin-spacing-2_top">スポーツ</h3>
  <textarea
    class="textarea_input"
    value="{ props.data.sports }"
    oninput="{ e => onText(e, 'sports') }"
  ></textarea>

  <script>
    export default {
      onText(e, name) {
        let data = this.props.data;
        data[name] = e.target.value;
        this.props.onUpdate(data);
      },
    };
  </script>
</sports>
